<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Ítem</h3>
      </div>
      <div class="layout__controls">
        <button v-show="searchButton && (permiteEditarItem || permiteEliminarItem)" @click="buscarItems" type="button" class="btn-info btn--bigger"><i class="fa fa-search"></i> <span>Buscar ítems</span></button>
        <modal height="auto" width="70%" scrollable name="listaItems">
          <lista-item :createButton="createButton" @selected="selectedItem"></lista-item>
        </modal>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información del ítem</h5>
            <div class="card__controls">
              <label v-show="tipoProducto === 'T'" for="producto"><input type="radio" id="producto" value="P" v-model="form.tipo_item"><span>Producto</span></label>
              <label v-show="tipoProducto === 'T'" for="servicio"><input type="radio" id="servicio" value="S" v-model="form.tipo_item"><span>Servicio</span></label>
            </div>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="codigo" placeholder="Código interno" v-model="form.codigo">
                    <span>Código *</span>
                    <span v-if="errores.codigo" class="helper-text text-danger" slot="helper">
                      {{ errores.codigo[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <p>
                  <label v-show="tipo === 'T'" for="radioEmpresa">
                    <input type="radio" id="radioEmpresa" v-model="form.tipo" value="E"><span>Item local</span>
                  </label>
                  <label v-show="tipo === 'T'" for="radioProveedor">
                    <input type="radio" id="radioProveedor" v-model="form.tipo" value="P"><span>Item de proveedor</span>
                  </label>
                </p>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="nombre" placeholder="Nombre del ítem" v-model="form.nombre">
                    <span>Nombre *</span>
                    <span v-if="errores.nombre" class="helper-text text-danger" slot="helper">
                      {{ errores.nombre[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <label for="mensual"><input type="checkbox" id="mensual" v-model="form.mensual"> <span>{{ 'Mensualizable' + (form.mensual?' (Digite el texto %mes% en el campo "descripción", el cual será reemplazado en las impresiones)':'') }}</span></label>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field id="descripcion" placeholder="Descripción del ítem" v-model="form.descripcion">
                    <span>Descripción</span>
                    <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                      {{ errores.descripcion[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select :options="categorias" label="nombre" v-model="selectedCategoria" id="categoria" placeholder="Seleccione..."></v-select>
                    <label for="categoria">Categoría *</label>
                    <span v-if="errores.id_categoria" class="helper-text text-danger" slot="helper">
                      {{ errores.id_categoria[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4" v-show="form.tipo_item === 'P'">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select :options="marcas" label="nombre" v-model="selectedMarca" id="marca" placeholder="Seleccione..."></v-select>
                    <label for="marca">Marca</label>
                    <span v-if="errores.id_marca" class="helper-text text-danger" slot="helper">
                      {{ errores.id_marca[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select :options="tarifasIva" label="nombre" v-model="selectedIva" id="iva" placeholder="Seleccione..."></v-select>
                    <label for="iva">Tarifa IVA *</label>
                    <span v-if="errores.iva_id" class="helper-text text-danger" slot="helper">
                      {{ errores.iva_id[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field vMoney :format="money2" id="precio_produccion" placeholder="Precio de producción o aduana"
                    v-model="form.precio_produccion">
                    <span>Precio de producción (ICE)</span>
                    <span v-if="errores.precio_produccion" class="helper-text text-danger" slot="helper">
                      {{ errores.precio_produccion[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field vMoney :format="decimal" id="cantidad_ice" placeholder="##" v-model="form.cantidad_ice">
                    <span>Cantidad gravada (ICE)</span>
                    <span v-if="errores.cantidad_ice" class="helper-text text-danger" slot="helper">
                      {{ errores.cantidad_ice[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select :options="tarifasIce" label="nombre" v-model="selectedIce" id="ice" placeholder="Seleccione..."></v-select>
                    <label for="ice">Tarifa ICE</label>
                    <span v-if="errores.ice_id" class="helper-text text-danger" slot="helper">
                      {{ errores.ice_id[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field vMoney :format="money2" id="precio" placeholder="Precio unitario" v-model="form.precio_venta">
                    <span>Precio de venta *</span>
                    <span v-if="errores.precio_venta" class="helper-text text-danger" slot="helper">
                      {{ errores.precio_venta[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field vMoney :format="money2" id="costo" placeholder="Costo unitario" v-model="form.costo">
                    <span>Costo *</span>
                    <span v-if="errores.costo" class="helper-text text-danger" slot="helper">
                      {{ errores.costo[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field vMoney :format="money2" id="precio" placeholder="$ ##.##" v-model="form.valor_subsidio">
                    <span>Valor subsidiado *</span>
                    <span v-if="errores.valor_subsidio" class="helper-text text-danger" slot="helper">
                      {{ errores.valor_subsidio[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4" v-show="form.irbpnr">
                <div class="form-field">
                  <input-field vMoney :format="decimal" id="precio" placeholder="IRBPNR" v-model="form.cantidad_irbpnr">
                    <span>Cantidad IRBPNR</span>
                    <span v-if="errores.cantidad_irbpnr" class="helper-text text-danger" slot="helper">
                      {{ errores.cantidad_irbpnr[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <label for="irbpnr"><input type="checkbox" id="irbpnr" v-model="form.irbpnr"> <span>IRBPNR</span></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button @click="guardarItem" type="button" class="btn-success"><i class="fa fa-save"></i> <span>Guardar</span></button>
            <button v-show="permiteCrearItem" @click="crearItem" type="button" class="btn-secondary btn--text"><i class="fa fa-plus"></i><span>Nuevo</span></button>
            <button v-show="estado === 'A' && permiteEliminarItem" @click="eliminarItem" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i> <span>Eliminar</span></button>
            <button v-show="estado === 'I' && permiteEliminarItem" @click="eliminarItem" type="button" class="btn-success btn--text"><i class="fa fa-power-off"></i> <span>Re-activar</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props : {
        createButton : {
            type: Boolean,
            default : false,
            required : false
        },
        searchButton : {
            type : Boolean,
            default : true,
            required : false
        },
        permiteCrearItem : {
            type : Boolean,
            default : true,
            required : false
        },
        permiteEditarItem : {
            type : Boolean,
            default : true,
            required : false
        },
        permiteEliminarItem : {
            type : Boolean,
            default : true,
            required : false
        },
        tipo : {
          type : String,
          default : 'T',
          required : false
        },
        tipoProducto : {
          type : String, 
          default : 'T',
          required : false
        }
    },
    methods : {
        buscarItems : function () {
            this.$modal.show('listaItems');
        },
        guardarItem : function () {
            let that = this;
            that.errores = {
                codigo : undefined,
                nombre : undefined,
                descripcion : undefined,
                iva_id : undefined,
                ice_id : undefined,
                precio_venta : undefined,
                tipo_item : undefined,
                irbpnr : undefined,
                id_marca : undefined,
                id_categoria : undefined,
                cantidad_ice : undefined,
                precio_produccion : undefined,
                cantidad_irbpnr : undefined,
                item : undefined,
                valor_subsidio : undefined
            };
            let urlRequest = that.url + '/items';
            if (that.estado !== 'N')
            {
                urlRequest += '/' + that.form.id;
                that.form._method = 'PUT';
            }
            else 
                that.form._method = undefined;
            axios.post(urlRequest, that.form).then(function (response) {
                that.form.id = response.data.id;
                that.estado = response.data.estado;
                swal('El ítem ha sido almacenado.', 'Realizado', 'success');
                that.$emit('saved', response.data);
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) 
                    {
                        let status = response.status;
                        if (status === 422) {
                            that.errores = response.data.errors;
                            swal('Hay errores de validación.', 'Aviso', 'warning');
                        }
                        else 
                            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                    }
                }
            });
        },
        eliminarItem : function () {
            let that = this;
            swal({
                title: '¿Desea ' + (this.estado === 'A'?'eliminar':'re-activar') + ' este ítem?',
                text: "El ítem será " + (this.estado === 'A'?'eliminado':'re-activado') + ".",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : (this.estado === 'A'?'Eliminar':'Re-activar'),
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        axios.post(that.url + '/items/' + that.form.id, {
                            _method : 'DELETE'
                        }).then(function (response) {
                            that.estado = response.data.estado;
                            swal('El ítem ha sido ' + (that.estado === 'I'?'eliminado':'re-activado') + '.', 'Realizado', 'success');
                        });
                    }
            });
        },
        limpiarFormulario : function () {
            this.form = {
                codigo : '',
                nombre : '',
                descripcion : '',
                iva_id : '',
                ice_id : '',
                precio_venta : 0,
                tipo_item : this.tipoProducto === 'T'?'P':this.tipoProducto,
                irbpnr : false,
                id_marca : '',
                id_categoria : '',
                id : '',
                _method : undefined,
                precio_produccion : 0,
                cantidad_ice : 0,
                precio_produccion : 0,
                cantidad_irbpnr : 0,
                tipo : 'E',
                valor_subsidio : 0,
                mensual : false
            };
            this.selectedIva = null;
            this.selectedIce = null;
            this.selectedCategoria = null;
            this.selectedMarca = null;
        },
        crearItem : function () {
            let that = this;
            swal({
                title: '¿Desea crear un nuevo ítem?',
                text: "El formulario será reiniciado.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : 'Crear nuevo',
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        that.limpiarFormulario();
                        that.estado = 'N';
                    }
            });
        },
        cargarDatos : function () {
            let that = this;
            axios.get(this.url + '/items/datos').then(function (response) {
                that.tarifasIva = response.data.tarifasIva;
                that.tarifasIce = response.data.tarifasIce;
                that.categorias = response.data.categorias;
                that.marcas = response.data.marcas;
            });
        },
        selectedItem : function (item) {
            this.selectedCategoria = null;
            this.selectedIce = null;
            this.selectedIva = null;
            this.selectedMarca = null;
            this.form.codigo = item.codigo;
            this.form.id = item.id;
            this.form.nombre = item.nombre;
            this.estado = item.estado;
            this.form.descripcion = item.descripcion;
            this.form.mensual = item.mensual === 'S';
            this.form.precio_venta = item.precio_venta;
            this.form.irbpnr = item.irbpnr === 'S';
            this.form.precio_produccion = item.precio_produccion;
            this.form.cantidad_ice = item.cantidad_ice;
            this.form.tipo_item = item.tipo_item;
            this.form.valor_subsidio = item.valor_subsidio;
            this.form.tipo = item.tipo;
            this.form.costo = item.costo;
            this.form.cantidad_irbpnr = item.cantidad_irbpnr;
            for (let i = 0; i < this.categorias.length; i++)
                if (this.categorias[i].id === item.id_categoria)
                    this.selectedCategoria = this.categorias[i];
            for (let i = 0; i < this.marcas.length; i++)
                if (this.marcas[i].id === item.id_marca)
                    this.selectedMarca = this.marcas[i];
            for (let i = 0; i < this.tarifasIva.length; i++)
                if (this.tarifasIva[i].id_tarifa === item.id_tarifa_iva)
                    this.selectedIva = this.tarifasIva[i];
            for (let i = 0; i < this.tarifasIce.length; i++)
                if (this.tarifasIce[i].id === item.id_categoria)
                    this.selectedCategoria = this.categorias[i];
            this.$modal.hide('listaItems');
        }
    },
    data : function () {
        return {
            form : {
                mensual : false,
                codigo : '',
                nombre : '',
                descripcion : '',
                iva_id : '',
                ice_id : '',
                precio_venta : 0,
                tipo_item : 'P',
                irbpnr : false,
                id_marca : '',
                id_categoria : '',
                id : '',
                _method : undefined,
                cantidad_ice : 0,
                precio_produccion : 0,
                cantidad_irbpnr : 0,
                tipo : this.tipo === 'T'?'E':this.tipo,
                valor_subsidio : 0,
                costo : 0,
                mensual : false
            },
            selectedIva : null,
            selectedIce : null,
            url : url,
            tarifasIva : [],
            tarifasIce : [],
            categorias : [],
            marcas : [],
            selectedCategoria : null,
            selectedMarca : null,
            money : money,
            money2 : money2,
            errores : {
                codigo : undefined,
                nombre : undefined,
                descripcion : undefined,
                iva_id : undefined,
                ice_id : undefined,
                precio_venta : undefined,
                tipo_item : undefined,
                irbpnr : undefined,
                id_marca : undefined,
                id_categoria : undefined,
                tipo : undefined
            },
            estado : 'N',
            decimal : decimal
        };
    },
    mounted : function () {
        this.cargarDatos();
    },
    watch : {
        selectedIva : function (value) {
            if (value !== undefined && value !== null)
                this.form.iva_id = value.id_tarifa;
            else 
                this.form.iva_id = '';
        },
        selectedIce : function (value) {
            if (value !== undefined && value !== null)
                this.form.ice_id = value.id_tarifa;
            else 
                this.form.ice_id = '';
        },
        selectedCategoria : function (value) {
            if (value !== undefined && value !== null)
                this.form.id_categoria = value.id;
            else 
                this.form.id_categoria = '';
        },
        selectedMarca : function(value) {
            if (value !== undefined && value !== null)
                this.form.id_marca = value.id;
            else 
                this.form.id_marca = '';
        },
        'form.tipo_item' : function (value) {
            if (value === 'S')
                this.selectedMarca = null;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/items/Item.vue